/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Search_PlaceholderInputs */

const en_knp_lookup_search_placeholder = /** @type {(inputs: Knp_Lookup_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search terms...`)
};

const fr_knp_lookup_search_placeholder = /** @type {(inputs: Knp_Lookup_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher des termes...`)
};

const de_knp_lookup_search_placeholder = /** @type {(inputs: Knp_Lookup_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchbegriffe...`)
};

const it_knp_lookup_search_placeholder = /** @type {(inputs: Knp_Lookup_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termini di ricerca...`)
};

const ru_knp_lookup_search_placeholder = /** @type {(inputs: Knp_Lookup_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поисковые запросы...`)
};

const es_knp_lookup_search_placeholder = /** @type {(inputs: Knp_Lookup_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Términos de búsqueda...`)
};

const zh_cn2_knp_lookup_search_placeholder = /** @type {(inputs: Knp_Lookup_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索词……`)
};

const ja_knp_lookup_search_placeholder = /** @type {(inputs: Knp_Lookup_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索用語...`)
};

const hi_knp_lookup_search_placeholder = /** @type {(inputs: Knp_Lookup_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोज शब्द...`)
};

const pt_pt2_knp_lookup_search_placeholder = /** @type {(inputs: Knp_Lookup_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termos de pesquisa...`)
};

/**
* | output |
* | --- |
* | "Search terms..." |
*
* @param {Knp_Lookup_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_search_placeholder = /** @type {((inputs?: Knp_Lookup_Search_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Search_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_search_placeholder(inputs)
	if (locale === "de") return de_knp_lookup_search_placeholder(inputs)
	if (locale === "it") return it_knp_lookup_search_placeholder(inputs)
	if (locale === "ru") return ru_knp_lookup_search_placeholder(inputs)
	if (locale === "es") return es_knp_lookup_search_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_search_placeholder(inputs)
	if (locale === "ja") return ja_knp_lookup_search_placeholder(inputs)
	if (locale === "hi") return hi_knp_lookup_search_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_search_placeholder(inputs)
	return en_knp_lookup_search_placeholder(inputs)
});